const AGENT_RESET = 'AGENT/RESET';

export default function agentResetAction () {
  return {
    type: AGENT_RESET,
    payload: { 
    }
  };
}

export { AGENT_RESET };